module.exports = __webpack_public_path__ + "static/media/04.b318781b.jpg";